module.exports = __webpack_public_path__ + "static/media/Twitter.6fb3f168.svg";